import Rating from '../../components/Rating';
import { ClipboardListIcon } from '@heroicons/react/solid';

export default function Evaluation() {
  return (
    <div className="w-full h-screen bg-white flex justify-center ">
      <section
        className="flex flex-col space-y-5 bg-white shadow-xl max-w-lg w-full p-12  rounded-lg mt-40"
        style={{ height: '650px' }}
      >
        <h1 className="font-semibold text-lg text-grey-dark flex space-x-3 items-center">
          <ClipboardListIcon className="w-5" />
          <p>Mentor Evaluatie</p>
        </h1>

        <h1>Voorbeeld 1</h1>
        <Rating rating={3} onChange={() => { }} />

        <h1>Voorbeeld 2</h1>
        <Rating rating={3} onChange={() => { }} />

        <h1>Voorbeeld 3</h1>
        <Rating rating={3} onChange={() => { }} />

        <h1>Toelichting</h1>
        <textarea
          className="w-full rounded-md border-none outline-none bg-grey-super_light"
          rows={5}
          placeholder={'Toelichting'}
        />

        <button
          type="button"
          className="bg-sky text-white rounded-md px-4 py-2 shadow-md hover:bg-sky-dark m-auto"
        >
          Versturen
        </button>
      </section>
    </div>
  );
}
